import React from 'react'
import classnames from 'classnames'

import './styles.scss'

export const TabItem = ({ item, isSelected, onClick }) => {
  const handleClick = () => {
    onClick(item)
  }

  return (
    <button
      className={classnames('tab-button', {
        'tab-button--selected': isSelected,
      })}
      onClick={handleClick}
    >
      {item}
    </button>
  )
}
